import * as React from 'react';
import {connect} from "react-redux";
import {RouteComponentProps} from 'react-router-dom';
import {Layout, Card, Icon} from 'antd';
import {loginRequest} from '@actions/auth';
import __i18n from "../intl/__i18n";

const {Content} = Layout;

type AllProps = RouteComponentProps<{}>

class LoginPage extends React.Component<AllProps> {
  
  redirect = () => {
    // this.props.history.push("/tags");
    // window.location.reload()
    // window.location.href = window.location.origin
  };
  redirectToResetPasswordPage = () => {
    this.props.history.push('/reset_password');
  };
  
  public render() {
    return (
     <div style={{textAlign:"center", fontSize:'30px', paddingTop:"50px"}}>
       <div>
         <Icon type="warning" />
       </div>
       <p>{__i18n("Not found Page")}</p>
     </div>
    )
  }
}


const mapDispatchToProps = {
  loginRequest,
};


export default connect(null, mapDispatchToProps)(LoginPage);


